module.exports = __webpack_public_path__ + "img/Multiview - Gray.6806a88f.png";